module.exports = __webpack_public_path__ + "static/media/vision.b5d64e8b.jpg";